const toggleCookieBanner = () => {
  try {
    window.OneTrust.ToggleInfoDisplay();
  } catch (e) {
    console.warn(
      `gatsby-plugin-pcs-cookie-banner: Could not toggle cookie banner. ${e}`
    );
  }
};

const changeCookieBannerLanguage = (lang) => {
  try {
    window.OneTrust.changeLanguage(lang);
  } catch (e) {
    console.warn(
      `gatsby-plugin-pcs-cookie-banner: Could not toggle language ${lang}. ${e}`
    );
  }
};

const isQuebecUser = () => {
  try {
    const location = getGeolocation();

    return (
      location?.state.toUpperCase() === "QC" &&
      location?.country.toUpperCase() === "CA"
    );
  } catch (e) {
    console.warn(
      `gatsby-plugin-pcs-cookie-banner: Could not get geolocation. ${e}`
    );
    return false;
  }
};

const getGeolocation = () => {
  try {
    return window.OneTrust.getGeolocationData();
  } catch (e) {
    console.warn(
      `gatsby-plugin-pcs-cookie-banner: Could not get geolocation. ${e}`
    );
  }
};

module.exports = {
  toggleCookieBanner,
  changeCookieBannerLanguage,
  isQuebecUser,
  getGeolocation,
};
